/**
 * Definições das cotas de plano. Precisa espelhar internal/subscription/plan_limits.go
 * no backend: mesmas chaves, mesma ordem e mesmo período.
 */

export const UNLIMITED = -1;

export const PERIOD_TOTAL = 'total';
export const PERIOD_MONTH = 'month';

export const PLAN_QUOTAS = [
    { key: 'printers', label: 'Impressoras', period: PERIOD_TOTAL },
    { key: 'products', label: 'Produtos', period: PERIOD_TOTAL },
    { key: 'commerce_partners', label: 'Parceiros', period: PERIOD_TOTAL },
    { key: 'customers', label: 'Clientes', period: PERIOD_MONTH },
    { key: 'checkouts', label: 'Pedidos', period: PERIOD_MONTH },
    { key: 'orders', label: 'Pedidos', period: PERIOD_MONTH },
    { key: 'quick_checkouts', label: 'Quick checkouts', period: PERIOD_MONTH },
    { key: 'jobs', label: 'Impressões', period: PERIOD_MONTH },
    { key: 'filaments', label: 'Filamentos', period: PERIOD_MONTH },
    { key: 'replacement_parts', label: 'Peças de reposição', period: PERIOD_MONTH },
    { key: 'transactions', label: 'Transações', period: PERIOD_MONTH },
    { key: 'reconciliations', label: 'Conciliações', period: PERIOD_MONTH },
	{ key: 'quotes', label: 'Orçamentos', period: PERIOD_MONTH },
    { key: 'operational_costs_recurring', label: 'Custos fixos recorrentes', period: PERIOD_TOTAL },
    { key: 'operational_costs_one_time', label: 'Custos fixos não recorrentes', period: PERIOD_MONTH },
];

const QUOTA_BY_KEY = PLAN_QUOTAS.reduce((acc, quota) => {
    acc[quota.key] = quota;
    return acc;
}, {});

export function findPlanQuota(key) {
    return QUOTA_BY_KEY[String(key || '').trim()] || null;
}

export function planQuotaLabel(key) {
    return findPlanQuota(key)?.label || String(key || '').trim();
}

/** "no total" / "por mês", para compor frases sobre o limite. */
export function planQuotaPeriodLabel(period) {
    return period === PERIOD_MONTH ? 'por mês' : 'no total';
}

/** Uma chave ausente significa ilimitado, para que novas cotas não bloqueiem ninguém. */
export function isUnlimitedLimit(limit) {
    return limit == null || Number(limit) < 0;
}

export function formatPlanLimit(limit) {
    return isUnlimitedLimit(limit) ? 'Ilimitado' : String(Number(limit));
}

/** Lê a cota de um plano vindo da API, cujos limites chegam como objeto plano. */
export function planLimitFor(plan, quotaKey) {
    const limits = plan?.limits;
    if (!limits) {
        return UNLIMITED;
    }
    const value = limits[quotaKey];
    return value == null ? UNLIMITED : Number(value);
}

/** Percentual consumido, já limitado a 100 para uso em barras de progresso. */
export function planUsagePercent(entry) {
    if (!entry || entry.unlimited || !entry.limit) {
        return 0;
    }
    return Math.min(100, Math.round((Number(entry.used) / Number(entry.limit)) * 100));
}
